export default [
  {
    path: '/cadastros/unidade-negocio/list',
    name: 'cadastros-unidade-negocio-list',
    component: () => import('@/views/cadastros/informacoes-organizacionais/unidade-negocio/list/Index.vue'),
    meta: {
      pageTitle: 'Unidades de Negócio',
      action: 'read',
      resource: 'UnidadeNegócio',
    },
  },
];
